import {Route, Routes} from 'react-router-dom'
import RecreacionPageWrapper from '../khipu/features/recreacion/pages/RecreacionPageWrapper'

const RecreacionRoutes = () => {
  return (
    <Routes>
      <Route index element={<RecreacionPageWrapper />} />
    </Routes>
  )
}

export {RecreacionRoutes}
